import { useAbTest, useTrackAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

const TRANSACTION_STATUS = {
  MONEY_PROCESSED: 230,
  MARKED_AS_SOLD: 452,
  COMPLETED_MANUALLY: 455,
}

type Props = {
  transactionStatus: number | null | undefined
  isSellerBusiness: boolean
  isCorrectUserSide: boolean
  abTestName: string
  shouldTrack?: boolean
}

export const useUserProtectionVisibility = ({
  transactionStatus,
  isSellerBusiness,
  isCorrectUserSide,
  abTestName,
  shouldTrack = true,
}: Props) => {
  const abTest = useAbTest(abTestName)
  const isAbTestEnabled = abTest?.variant === 'on'

  const isTransactionPostOrder =
    !!transactionStatus &&
    transactionStatus >= TRANSACTION_STATUS.MONEY_PROCESSED &&
    transactionStatus !== TRANSACTION_STATUS.MARKED_AS_SOLD &&
    transactionStatus !== TRANSACTION_STATUS.COMPLETED_MANUALLY

  const isUserProtectionVisible =
    !!transactionStatus &&
    isTransactionPostOrder &&
    !isSellerBusiness &&
    isCorrectUserSide &&
    shouldTrack

  useTrackAbTest(abTest, isUserProtectionVisible)

  return isUserProtectionVisible && isAbTestEnabled
}
